import { render } from "./MallConsumptionTrend.vue?vue&type=template&id=2b45b45a&scoped=true"
import script from "./MallConsumptionTrend.vue?vue&type=script&lang=js"
export * from "./MallConsumptionTrend.vue?vue&type=script&lang=js"

import "./MallConsumptionTrend.vue?vue&type=style&index=0&id=2b45b45a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b45b45a"]])

export default __exports__